import { api } from '@/utils/api'

import { ApiResponseHandler, Gettable } from './ApiInterfaces'
import { ApiBase, ResponseError } from './ApiBase'

/**
 * 月例テスト教科別成績取得
 */
export namespace ApiTaRe050 {
  // API Name
  export const name: string = 'ApiTaRe050'

  // GET parameters
  export namespace Get {
    export const path: string = '/ta/monthlyTestSubjectResult'

    export interface Request {
      query: {
        fiscalYear: number
        month: number
        times?: number
        grade: number
        courseId: string
        subjectCode: string
      }
    }

    export interface Response {
      monthlyTestSubjectGrade: {
        memNum: string
        results: {
          questionNo: string
          subQuestionNo: string
          difficultyLevel: string
          allocation: string
          score: string
          average: string
        }[]
      }
    }
  }

  // API本体
  export class Api extends ApiBase implements Gettable<Get.Request, Get.Response, ResponseError> {
    // GET
    public get<R>(
      params: Get.Request,
      successHandler: ApiResponseHandler<Get.Response, R>,
      errorHandler: ApiResponseHandler<ResponseError, R>
    ): Promise<R | null> {
      // 成功時のレスポンス構造サンプル
      const validationSample: Get.Response = {
        monthlyTestSubjectGrade: {
          memNum: '',
          results: [
            {
              questionNo: '',
              subQuestionNo: '',
              difficultyLevel: '',
              allocation: '',
              score: '',
              average: '',
            },
          ],
        },
      }

      // エラー時のレスポンス構造サンプル
      const validationErrorSample: ResponseError = {
        error: {
          messageId: '',
          message: '',
        },
      }

      // API呼び出し
      return this.callbackWrapper<Get.Response, ResponseError, R>(
        api.get<Get.Response>(Get.path, { params: params.query }),
        successHandler,
        errorHandler,
        validationSample,
        validationErrorSample
      )
    }
  }
}
